import ABI from "src/contract-logic/abis/TokenFaucetABI.json";
import { getCurrentContractAddresses } from "src/configs/address";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { TOKEN_FAUCET_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, TOKEN_FAUCET_ADDRESS);
  }
  if (!contractReader) {
    throw new Error("Failed to create token-faucet contract reader");
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, TOKEN_FAUCET_ADDRESS);
  }
  if (!contractSender) {
    throw new Error("Failed to create token-faucet contract sender");
  }
  return contractSender;
}

async function withdrawNFT(tokenId, tokenAmount, accountAddress, data = "0x00") {
  const res = await getContractSender().methods.withdrawNft(tokenId, tokenAmount, data).send({ from: accountAddress });
  return res;
}

async function getAllowance(ownerAddress, tokenId) {
  const res = await getContractReader().methods.getAllowance(ownerAddress, tokenId).call();
  return parseInt(res);
}

export default {
  ABI,
  ADDRESS: TOKEN_FAUCET_ADDRESS,
  withdrawNFT,
  getAllowance,
};
